import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reportAction } from '@api/activityLogApi';
import { openNotification } from '@state/notifications/actions';
import { pingKind } from '@state/notifications/operations';
import { getId } from '@state/semester/selectors';
import { onSessionNoticeClick, SessionPing, takeSessionFromAddress } from '@utils/sessionNotice';

/** Clicks on the session pings' desktop notices: in this tab, or the one a click opened (notifications cleanup). */
export function useSessionPingClicks() {
  const dispatch = useDispatch();
  const semesterId = useSelector(getId);

  useEffect(() => {
    if (!semesterId) return;
    const open = (ping: SessionPing) => {
      reportAction('session_ping_clicked', { kind: pingKind(ping.type), from: 'notice' });
      dispatch(openNotification(ping));
    };
    const fromAddress = takeSessionFromAddress();
    if (fromAddress) open(fromAddress);
    return onSessionNoticeClick(open);
  }, [dispatch, semesterId]);
}
